import { render } from "./RegisterNewUser.vue?vue&type=template&id=c9ec822e&scoped=true"
import script from "./RegisterNewUser.vue?vue&type=script&lang=js"
export * from "./RegisterNewUser.vue?vue&type=script&lang=js"

import "./RegisterNewUser.vue?vue&type=style&index=0&id=c9ec822e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ec822e"]])

export default __exports__